import {
    CHANGE_EMAIL,
    CHANGE_NAME,
    CHANGE_PHONE_NUMBER,
    CHANGE_RETYPE_EMAIL, CHANGE_SELECTED_COUNTRY,
    CHANGE_TARGET_POSITION
} from "../actions";

const initialState = {
    isCusotomerLoggedIn: window.orderFormInitialState.isCusotomerLoggedIn,
    filledTargetPosition: window.orderFormInitialState.filledTargetPosition,
    filledName: window.orderFormInitialState.filledName,
    filledEmail: window.orderFormInitialState.filledEmail,
    filledRetypeEmail: window.orderFormInitialState.filledRetypeEmail,
    selectedCountry: window.orderFormInitialState.selectedCountry,
    filledPhoneNumber: window.orderFormInitialState.filledPhoneNumber,
}

const personalInfo = (state = initialState, action) => {
    switch (action.type) {
        case CHANGE_TARGET_POSITION:
            return Object.assign({}, state, {
                filledTargetPosition: action.value
            })
        case CHANGE_NAME:
            return Object.assign({}, state, {
                filledName: action.value
            })
        case CHANGE_EMAIL:
            return Object.assign({}, state, {
                filledEmail: action.value
            })
        case CHANGE_RETYPE_EMAIL:
            return Object.assign({}, state, {
                filledRetypeEmail: action.value
            })
        case CHANGE_PHONE_NUMBER:
            return Object.assign({}, state, {
                filledPhoneNumber: action.value
            })
        case CHANGE_SELECTED_COUNTRY:
            return Object.assign({}, state, {
                selectedCountry: action.countryId
            })
        default:
            return state
    }
}

export default personalInfo